import { render, staticRenderFns } from "./TimeRecordingOverviewRelation.vue?vue&type=template&id=40b7ecce&"
import script from "./TimeRecordingOverviewRelation.vue?vue&type=script&lang=js&"
export * from "./TimeRecordingOverviewRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports